<template>
    <div id="app" class="flex">
        <transition
            name="fade"
            mode="out-in"
        >
            <router-view />
        </transition>
    </div>
</template>
<script>
import WebFontLoader from 'webfontloader';
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['UIState']),
    },

    /**
     * Handles "created" action.
     */
    created() {
        WebFontLoader.load({
            custom: {
                families: ['Europa:n4,n7,i4,i7'],
            },
            timeout: 2000,
        });

        window.addEventListener('beforeunload', this.beforeUnload);
    },

    /**
     * Handles "beforeDestroy" action.
     */
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeUnload);
    },

    methods: {
        /**
         * Handles before unload event.
         *
         * @param  {Event} event Before unload event.
         */
        beforeUnload(event) {
            if (this.UIState.preventUnload) {
                event.preventDefault();
                event.returnValue = '';
            }
        },
    },
};
</script>
